import React, { useMemo } from 'react';
import './SchemeRightSidebar.css';

const SchemeRightSidebar = ({ projects }) => {
  const topStates = useMemo(() => {
    if (!projects || projects.length === 0) return [];

    // ✅ Group and sum BR for each unique state
    const stateMap = {};
    projects.forEach((project) => {
      const state = project.st_nm;
      const br = Number(project.BR) || 0;
      stateMap[state] = (stateMap[state] || 0) + br;
    });

    // ✅ Convert to array, sort by totalBR desc, and take top 5
    return Object.entries(stateMap)
      .map(([state, totalBR]) => ({ state, totalBR }))
      .sort((a, b) => b.totalBR - a.totalBR)
      .slice(0, 5);
  }, [projects]);

  return (
    <div className="scheme-right-sidebar">
      <h3>Top States by BR</h3>
      <div className="scheme-content">
        {topStates.map((item, index) => (
          <div key={index} className="scheme-card">
            <h4>{index + 1}. {item.state}</h4>
            {/* <div className="scheme-info">
              <p><strong>BR:</strong> {item.totalBR}</p>
            </div> */}
          </div>
        ))}
      </div>
    </div>
  );
};

export default SchemeRightSidebar;
